import { Box, Flex, Image, Text } from '@chakra-ui/react';
import { PredictionsResultBreakdownItem } from '@/model/predictions';

export interface PredictionsResultBreakdownRowProps {
  rank: number;
  item: PredictionsResultBreakdownItem;
  maxPercentage: number;
  optionAImageUrl: string | null;
  optionBImageUrl: string | null;
  isHit: boolean;
}

export const PredictionsResultBreakdownRow = ({
  rank,
  item,
  maxPercentage,
  optionAImageUrl,
  optionBImageUrl,
  isHit,
}: PredictionsResultBreakdownRowProps) => {
  const barWidth = maxPercentage > 0 ? (item.percentage / maxPercentage) * 100 : 0;

  return (
    <Flex alignItems='center' gap={3}>
      <Text w='16px' fontWeight='bold' color='gray.500'>
        {rank}
      </Text>

      <Flex alignItems='center' gap={1} minW='96px'>
        {optionAImageUrl ? <Image src={optionAImageUrl} alt='' w='20px' h='20px' objectFit='contain' /> : null}
        <Text fontWeight={isHit ? 'bold' : 'normal'} color={isHit ? 'brand.500' : undefined}>
          {item.option_a_result} x {item.option_b_result}
        </Text>
        {optionBImageUrl ? <Image src={optionBImageUrl} alt='' w='20px' h='20px' objectFit='contain' /> : null}
      </Flex>

      <Box flex='1' bg='gray.100' borderRadius='full' h='8px' overflow='hidden'>
        <Box bg={isHit ? 'brand.500' : 'gray.400'} h='100%' borderRadius='full' width={`${barWidth}%`} />
      </Box>

      <Text minW='120px' textAlign='right' color='gray.600'>
        {item.total_participations} palpites
      </Text>
      <Text minW='56px' textAlign='right' fontWeight='bold' color={isHit ? 'brand.500' : undefined}>
        {item.percentage.toFixed(1)}%
      </Text>
    </Flex>
  );
};
